import { Observable } from '../Observable';
export function throwError(errorFactory) {
    return new Observable(function (subscriber) {
        subscriber.error(errorFactory());
    });
}
//# sourceMappingURL=throwError.js.map